export enum FileExtension {
	JPEG = '.jpeg',
	PNG = '.png'
}
